import { mapState } from 'pinia';
import { useAdminProjectContextStore } from '@/Stores/Admin/projectContextStore';
import { useProjectAdditionalInfoStore } from '@/Stores/Admin/projectAdditionalInfoStore';

export default {
    computed: {
        latePledgeProjectSettingsMessage() {
            return this.isLatePledge
                ? 'Your project is currently in the late pledge stage. You can edit these settings, but they will have their effect and be available to backers after the pledge manager is open.'
                : null;
        },
        latePledgeLocationsSettingsMessage() {
            return this.taxHandlingEnabled
                ? null
                : this.latePledgeProjectSettingsMessage;
        },
        latePledgeShippingSettingsMessage() {
            return this.earlyShippingCollectionEnabled
                ? null
                : this.latePledgeProjectSettingsMessage;
        },
        taxHandlingEnabled() {
            return this.projectAdditionalInfo?.enableTaxHandling;
        },
        earlyShippingCollectionEnabled() {
            return this.projectAdditionalInfo?.earlyShippingCollectionEnabled;
        },
        ...mapState(useAdminProjectContextStore, ['isLatePledge']),
        ...mapState(useProjectAdditionalInfoStore, ['projectAdditionalInfo']),
    },
};